import Global from '../../global';
import { Level } from '@unified-client/event-formatter';
import ClickstreamFacade from '../../facades/clickstream-facade';
import { enums } from '@888sport/uc-sportclient-lib/dist/uc-sportclient-lib.min';
const { eSources } = enums;

export default {
  getPerformance: function() {
    return performance;
  },

  startWatch: function(watchName) {
    this.getPerformance().mark(watchName);
    Global.logger.info(`Started watch '${watchName}'`);
  },

  isStartedWatch: function(watchName) {
    const watches = this.getPerformance().getEntriesByName(watchName, 'mark');
    return watches.length > 0;
  },

  /**
   * It calculates duration from given watchName.
     If no watchName provided, calculate to now.
   * @param {string} measureName 
   * @param {string} fromWatchName 
   */
  getDuration: function(measureName, fromWatchName) {
    var performanceApi = this.getPerformance();

    if (fromWatchName !== undefined) {
      Global.logger.info(
        `Measuring duration for measure '${measureName}' from watch '${fromWatchName}'`
      );

      const isStartedWatch = this.isStartedWatch(fromWatchName);
      if (!isStartedWatch) {
        Global.logger.info(
          `Failed to measure duration for measure '${measureName}' and watch '${fromWatchName}'. No such watch exists`
        );

        return null;
      }

      performanceApi.measure(measureName, fromWatchName);
    } else {
      Global.logger.info(
        `Measuring duration for measure '${measureName}' from navigation start time`
      );

      performanceApi.measure(measureName);
    }

    const performanceMeasure = performanceApi
      .getEntriesByName(measureName)
      .pop();

    if (performanceMeasure) {
      performanceApi.clearMeasures(measureName);

      return performanceMeasure.duration;
    }

    Global.logger.error(
      `Failed to measure duration for measure '${measureName}' ${
        fromWatchName !== undefined ? `and '${fromWatchName}'` : ''
      }`
    );

    return null;
  },

  clearWatches: function(performanceWatchesNames) {
    Global.logger.info(`Trying to stop watches '${performanceWatchesNames}'`);
    var performanceApi = this.getPerformance();

    performanceWatchesNames.forEach(watchName => {
      var watchEntries = performanceApi.getEntriesByName(watchName);
      if (watchEntries.length > 0) {
        performanceApi.clearMarks(watchName);
        Global.logger.info(`Stopped watch '${watchName}'`);
      }
    });
  },

  /**
   * Sends a report to elastic (info) with given event.
     It calculates duration from given watchName.
     If no watchName provided, calculate to now.
   * @param {string} eventName - elastic event
   * @param {string} eventStaticData - other data to be logged
   * @param {string} measureName 
   * @param {string} watchName 
   * @param {boolean} clearWatch 
   */
  sendDurationReport: function(
    eventName,
    eventStaticData,
    measureName,
    watchName = undefined,
    clearWatch = false
  ) {
    const duration = this.getDuration(measureName, watchName);
    if (duration != null) {
      Global.logger.info(
        `Sending report : event --> '${eventName}' duration --> '${duration}', for measure '${measureName}' ${
          watchName !== undefined ? `and '${watchName}'` : ''
        }`
      );

      const eventData = {
        type: eventName,
        durationInMs: duration,
        source: eSources.client
      };

      ClickstreamFacade.sendEventToClickstream(
        eventData,
        Level.information,
        eventStaticData
      );
    } else
      Global.logger.error(
        `Failed to send duration report for event '${eventName}'`
      );

    if (clearWatch === true && watchName !== undefined)
      this.clearWatches([watchName]);
  }
};
